import { useWatch } from 'react-hook-form'

import type { ConfigFieldContext } from '../ConfigFields/ConfigFields'
import {
  collectColumnEntries,
  getConflictingColumnKeys,
} from '../lib/configColumnConflicts'
import type { PriceFieldContext } from '../PricesStep/PriceFields'
export const useColumnConflicts = (
  context: ConfigFieldContext,
  priceContext: PriceFieldContext
) => {
  const [
    articleColumnNumber,
    articleInchColumnNumber,
    barcodeColumnNumber,
    descriptionColumnNumber,
    brandColumnNumber,
    quantityColumnNumber,
  ] = useWatch({
    control: context.control,
    name: [
      'articleColumnNumber',
      'articleInchColumnNumber',
      'barcodeColumnNumber',
      'descriptionColumnNumber',
      'brandColumnNumber',
      'quantityColumnNumber',
    ],
  })
  const [
    enabled,
    currencyFromFile,
    segments,
    purchaseColumnNumber,
    rrcColumnNumber,
    currencyColumnNumber,
  ] = useWatch({
    control: priceContext.control,
    name: [
      'enabled',
      'currencyFromFile',
      'segments',
      'purchaseColumnNumber',
      'rrcColumnNumber',
      'currencyColumnNumber',
    ],
  })

  return getConflictingColumnKeys(
    collectColumnEntries(
      {
        articleColumnNumber,
        articleInchColumnNumber,
        barcodeColumnNumber,
        descriptionColumnNumber,
        brandColumnNumber,
        quantityColumnNumber,
      },
      {
        enabled,
        currencyFromFile,
        segments,
        purchaseColumnNumber,
        rrcColumnNumber,
        currencyColumnNumber,
      }
    )
  )
}
